import { Image, View } from "@react-pdf/renderer";
import PdfFooter from "../../../assets/print/pdfFooter.png";

export default function PrintFooter() {
    return (
        <View
            style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                paddingTop: 10,
            }}
            fixed
        >
            <Image src={PdfFooter} style={{ width: "400px" }} />
        </View>
    );
}
